import React from 'react';
import { Field, FieldHint, Input } from '../../ui';
import { Document } from './ShippingForm';

interface DocumentFormProps {
  document: Document;
  index: number;
  unitSystem: 'metric' | 'imperial';
  onUpdateDocument: (id: string, field: string, value: any) => void;
  onRemoveDocument: (id: string) => void;
  canRemove: boolean;
  documentSizes?: Array<{ value: string; label: string }>;
}

const DocumentForm: React.FC<DocumentFormProps> = ({
  document,
  index,
  unitSystem,
  onUpdateDocument,
  onRemoveDocument,
  canRemove,
}) => {
  const weightUnit = unitSystem === 'metric' ? 'kg' : 'lb';
  const maxWeight = unitSystem === 'metric' ? 0.5 : 1.1;

  const handleWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value) && value >= 0 && value <= maxWeight) {
      onUpdateDocument(document.id, 'weight', value);
    }
  };

  return (
    <div
      style={{
        padding: 16,
        marginBottom: 8,
        borderRadius: 8,
        border: '1px solid var(--line)',
        position: 'relative',
        background: 'var(--bg-elev)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontWeight: 600, fontSize: 13, color: 'var(--ink-2)' }}>Document {index + 1}</span>
        {canRemove && (
          <button
            type="button"
            onClick={() => onRemoveDocument(document.id)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: 'var(--ink-3)',
              padding: '2px 6px',
              borderRadius: 4,
              fontSize: 18,
              lineHeight: 1,
            }}
            aria-label="Remove document"
          >
            ×
          </button>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <Field label="Quantity">
          <Input type="number" value={1} min={1} max={1} disabled />
          <FieldHint>Documents ship as a single envelope</FieldHint>
        </Field>
        <Field label={`Weight (${weightUnit})`}>
          <Input
            type="number"
            value={document.weight}
            onChange={handleWeightChange}
            min={0}
            max={maxWeight}
            step={0.01}
          />
          <FieldHint>Maximum {maxWeight} {weightUnit} for documents</FieldHint>
        </Field>
      </div>
    </div>
  );
};

export default DocumentForm;
